import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogBodyComponent } from './dialog-body/dialog-body.component';
import { DialogComponent } from './dialog/dialog.component';

import { FormsModule } from '@angular/forms';

import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { DialogTaskComponent } from './dialog-task/dialog-task.component';
import { DialogBodyTaskComponent } from './dialog-body-task/dialog-body-task.component';
import { DialogPermissionsKanbanComponent } from './dialog-permissions-kanban/dialog-permissions-kanban.component';
import { GButtonComponent } from 'src/app/+home/shared/components/g-button/g-button.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { SeePermissionsComponent } from './dialog-permissions-kanban/see-permissions/dist/see-permissions.component';
import { SeePermissionsKanbanComponent } from './dialog-permissions-kanban/see-permissions/see-permissions-kanban.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { DialogLookupPermissionsComponent } from 'src/app/+home/+my-libraries/+sites/document-library/shared/dialog-lookup-permissions/dialog-lookup-permissions.component';
import { DialogEditTitleComponent } from './dialog-editTitle/dialog-editTitle.component';
import { SeeAffectationKanbanComponent } from './see-affectation/see-affectation-kanban.component';
import { DialogEditSkillComponent } from 'src/app/+home/+seller-consultants/seller-add-consultant/shared/dialog-edit-skill/dialog-edit-skill.component';

@NgModule({
  declarations: [
    DialogComponent,
    DialogBodyComponent,
    DialogEditSkillComponent,
    DialogTaskComponent,
    DialogPermissionsKanbanComponent,
    DialogBodyTaskComponent,
    DialogEditTitleComponent,
    SeePermissionsKanbanComponent,
   ],
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    SharedModule,
    MatInputModule,
    MatButtonToggleModule,

  ],
  exports: [
    DialogComponent,
    DialogTaskComponent,
    DialogPermissionsKanbanComponent,
    DialogEditTitleComponent,
    SeePermissionsKanbanComponent,


  ]
})
export class KanbanDialogModule { }
